import { api } from "@/api/client";

export type ActionPlan = {
  id: string;
  assessment_id: string;
  threat_id: string;
  risk_priority: string;
  action_required: string;
  responsible_person: string | null;
  target_date: string | null;
  status: string;
  completion_date: string | null;
  evidence: string | null;
  roi_estimate: string | null;
  created_at: string;
};

export type ActionPlanCreate = {
  threat_id: string;
  action_required: string;
  responsible_person?: string | null;
  target_date?: string | null;
  status?: string;
  completion_date?: string | null;
  evidence?: string | null;
  roi_estimate?: string | null;
};

export type ActionPlanUpdate = Partial<
  Omit<ActionPlanCreate, "threat_id">
>;

export type ActionPlanListParams = {
  limit?: number;
  offset?: number;
  status?: string;
};

function toSearchParams(
  params: ActionPlanListParams | undefined,
): URLSearchParams | undefined {
  if (!params) return undefined;
  const sp = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    const str = String(value);
    if (str === "" || str === "undefined") continue;
    sp.append(key, str);
  }
  return sp;
}

export async function listActionPlans(
  params?: ActionPlanListParams,
): Promise<ActionPlan[]> {
  return api
    .get("action-plans", { searchParams: toSearchParams(params) })
    .json<ActionPlan[]>();
}

export async function listActionPlansForAssessment(
  assessmentId: string,
): Promise<ActionPlan[]> {
  return api
    .get(`assessments/${assessmentId}/action-plans`)
    .json<ActionPlan[]>();
}

export async function createActionPlan(
  assessmentId: string,
  payload: ActionPlanCreate,
): Promise<ActionPlan> {
  return api
    .post(`assessments/${assessmentId}/action-plans`, { json: payload })
    .json<ActionPlan>();
}

export async function updateActionPlan(
  id: string,
  payload: ActionPlanUpdate,
): Promise<ActionPlan> {
  return api.patch(`action-plans/${id}`, { json: payload }).json<ActionPlan>();
}

export async function deleteActionPlan(id: string): Promise<void> {
  await api.delete(`action-plans/${id}`);
}
